import script from "./Products.vue?vue&type=script&setup=true&lang=js"
export * from "./Products.vue?vue&type=script&setup=true&lang=js"

import "./Products.vue?vue&type=style&index=0&id=3b463d3e&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b463d3e"]])

export default __exports__